import { render } from "./MainProductMovement.vue?vue&type=template&id=013b1a91&scoped=true"
import script from "./MainProductMovement.vue?vue&type=script&lang=js"
export * from "./MainProductMovement.vue?vue&type=script&lang=js"

import "./MainProductMovement.vue?vue&type=style&index=0&id=013b1a91&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013b1a91"]])

export default __exports__